var gtg_modal, setSiteCookies;

setSiteCookies = require('../../../../core/frontend/groupon_modules/setSiteCookies');


/*
 *  LS-2476 / LS-2480 - GTG (GrouponToGo) modal shared code across desktop / touch / m2016
 */

gtg_modal = (function() {
  return {
    init: function() {
      var $html, $modal, $modalAndWrapper, $picture, $wrapper, highres, lowres, ref;
      if ((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem('gtg_modal') : void 0) || Cookie.get('gtg_modal')) {
        return;
      }
      if (!($modal = $('#ls-gtg-modal')).length) {
        return;
      }
      $wrapper = $('#ls-modals-wrapper');
      $html = $('html');
      $modalAndWrapper = $wrapper.add($modal);
      $picture = $modal.find('#ls-gtg-image');
      ref = $picture.data(), lowres = ref.lowres, highres = ref.highres;
      $picture.prepend("<source media='(min-width: 600px)' srcset='" + highres + "'>");
      $picture.find('img').one('load', function() {
        $modalAndWrapper.removeClass('ls-hide');
        return $html.addClass('blockContentScrolling');
      }).attr('src', lowres);
      $modal.on('click', function(e) {
        e.preventDefault();
        return e.stopImmediatePropagation();
      });
      return $wrapper.add('.ls-gtg-content a').one('click', function(e) {
        $modal.off('click');
        e.stopImmediatePropagation();
        if (localStorage) {
          if (typeof localStorage !== "undefined" && localStorage !== null) {
            localStorage.setItem('gtg_modal', true);
          }
        } else {
          setSiteCookies({
            gtg_modal: true
          }, 60 * 60 * 24 * 30);
        }
        $modalAndWrapper.addClass('ls-hide');
        return $html.removeClass('blockContentScrolling');
      });
    }
  };
})();

module.exports = gtg_modal;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9tb2R1bGVzL3NoYXJlZC9tb2RhbHMvZnJvbnRlbmQvZ3RnLW1vZGFsLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvbW9kdWxlcy9zaGFyZWQvbW9kYWxzL2Zyb250ZW5kL2d0Zy1tb2RhbC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxjQUFBLEdBQWlCLE9BQUEsQ0FBUSwwREFBUjs7O0FBRWpCOzs7O0FBR0EsU0FBQSxHQUFlLENBQUEsU0FBQTtTQUNiO0lBQUEsSUFBQSxFQUFNLFNBQUE7QUFDSixVQUFBO01BQUEsb0VBQVUsWUFBWSxDQUFFLE9BQWQsQ0FBc0IsV0FBdEIsV0FBQSxJQUFzQyxNQUFNLENBQUMsR0FBUCxDQUFXLFdBQVgsQ0FBaEQ7QUFBQSxlQUFBOztNQUNBLElBQVUsQ0FBSSxDQUFDLE1BQUEsR0FBUyxDQUFBLENBQUUsZUFBRixDQUFWLENBQTZCLENBQUMsTUFBNUM7QUFBQSxlQUFBOztNQUVBLFFBQUEsR0FBVyxDQUFBLENBQUUsb0JBQUY7TUFDWCxLQUFBLEdBQVEsQ0FBQSxDQUFFLE1BQUY7TUFDUixnQkFBQSxHQUFtQixRQUFRLENBQUMsR0FBVCxDQUFhLE1BQWI7TUFDbkIsUUFBQSxHQUFXLE1BQU0sQ0FBQyxJQUFQLENBQVksZUFBWjtNQUNYLE1BQW9CLFFBQVEsQ0FBQyxJQUFULENBQUEsQ0FBcEIsRUFBQyxtQkFBRCxFQUFTO01BQ1QsUUFBUSxDQUFDLE9BQVQsQ0FBaUIsNkNBQUEsR0FBOEMsT0FBOUMsR0FBc0QsSUFBdkU7TUFDQSxRQUFRLENBQUMsSUFBVCxDQUFjLEtBQWQsQ0FBb0IsQ0FBQyxHQUFyQixDQUF5QixNQUF6QixFQUFpQyxTQUFBO1FBQy9CLGdCQUFnQixDQUFDLFdBQWpCLENBQTZCLFNBQTdCO2VBQ0EsS0FBSyxDQUFDLFFBQU4sQ0FBZSx1QkFBZjtNQUYrQixDQUFqQyxDQUdDLENBQUMsSUFIRixDQUdPLEtBSFAsRUFHYyxNQUhkO01BTUEsTUFBTSxDQUFDLEVBQVAsQ0FBVSxPQUFWLEVBQW1CLFNBQUMsQ0FBRDtRQUNqQixDQUFDLENBQUMsY0FBRixDQUFBO2VBQ0EsQ0FBQyxDQUFDLHdCQUFGLENBQUE7TUFGaUIsQ0FBbkI7YUFJQSxRQUFRLENBQUMsR0FBVCxDQUFhLG1CQUFiLENBQWlDLENBQUMsR0FBbEMsQ0FBc0MsT0FBdEMsRUFBK0MsU0FBQyxDQUFEO1FBQzdDLE1BQU0sQ0FBQyxHQUFQLENBQVcsT0FBWDtRQUNBLENBQUMsQ0FBQyx3QkFBRixDQUFBO1FBQ0EsSUFBRyxZQUFIOztZQUNFLFlBQVksQ0FBRSxPQUFkLENBQXNCLFdBQXRCLEVBQW1DLElBQW5DO1dBREY7U0FBQSxNQUFBO1VBR0UsY0FBQSxDQUFlO1lBQUMsU0FBQSxFQUFXLElBQVo7V0FBZixFQUFrQyxFQUFBLEdBQUssRUFBTCxHQUFVLEVBQVYsR0FBZSxFQUFqRCxFQUhGOztRQUlBLGdCQUFnQixDQUFDLFFBQWpCLENBQTBCLFNBQTFCO2VBQ0EsS0FBSyxDQUFDLFdBQU4sQ0FBa0IsdUJBQWxCO01BUjZDLENBQS9DO0lBcEJJLENBQU47O0FBRGEsQ0FBQSxDQUFILENBQUE7O0FBK0JaLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
